import { Link } from 'react-router-dom'
import Card from '../UI/Card'

const Trainer = ({ instructor_id, image, name, job, socials }) => {
    return (
        <Card className='trainer'>
            <div className="trainer__img">
                <img src={image} alt={name} className='h-64' />
            </div>
            <h3 className='text-white'><Link className='text-[#c7b262]' to={`/profile/${instructor_id}/trainer`}>{name}</Link></h3>
            <p>{job}</p>
            <div className="trainer__social">
                {
                    socials.map(({ icon, link }, index) => {
                        return <a key={index} href={link} target="_blank" rel="noreferrer noopener">{icon}</a>
                    })
                }
            </div>
        </Card>
    )
}

export default Trainer